import {Component} from '@angular/core';
import {AngularTokenService} from '@lakshvairav/angular-token';
import {Router} from '@angular/router';

@Component({
  selector: 'forgot-password-submit',
  templateUrl: 'forgot-password-submit.component.html'
})
export class ForgotPasswordSubmitComponent {
  email:string=""
  constructor(private router: Router,private _tokenService: AngularTokenService) {
  }
  Login(): void {
    //event.preventDefault();
     this.router.navigate(['/sign-in']);
  }

  ngOnInit() {
    this.email = JSON.parse(localStorage.getItem('current_email'));
  }
}